import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../../i18n';

const NAV_ITEMS = [
  {
    path: '/deposit', labelKey: 'menu.deposit',
    icon: <svg viewBox="0 0 20 20" fill="none"><rect x="3" y="11" width="14" height="7" rx="2" stroke="currentColor" strokeWidth="1.4"/><path d="M10 2v9m0 0l-3-3m3 3l3-3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>,
  },
  {
    path: '/withdrawal', labelKey: 'menu.withdraw',
    icon: <svg viewBox="0 0 20 20" fill="none"><rect x="3" y="2" width="14" height="7" rx="2" stroke="currentColor" strokeWidth="1.4"/><path d="M10 18V9m0 0l-3 3m3-3l3 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>,
  },
  {
    path: '/transactions', labelKey: 'menu.transactions',
    icon: <svg viewBox="0 0 20 20" fill="none"><path d="M4 6h12M4 10h8M4 14h5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>,
  },
  {
    path: '/favoris', labelKey: 'menu.favorites',
    icon: <svg viewBox="0 0 20 20" fill="none"><path d="M10 3.5l1.8 3.6 4 .58-2.9 2.83.69 4L10 12.5l-3.59 1.89.69-4L4.2 7.68l4-.58z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/></svg>,
  },
  {
    path: '/profile/edit', labelKey: 'menu.myProfile',
    icon: <svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="7" r="3" stroke="currentColor" strokeWidth="1.4"/><path d="M4 17c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>,
  },
];

const css = `
  .psn { display: flex; overflow-x: auto; gap: 0; padding: 0 12px; background: #0e0c22; border-bottom: 1px solid rgba(255,255,255,.06); scrollbar-width: none; }
  .psn::-webkit-scrollbar { display: none; }
  .psn-item { flex: none; display: flex; flex-direction: column; align-items: center; gap: 4px; padding: 10px 14px 8px; font-size: 11px; font-weight: 600; color: #6a6982; white-space: nowrap; border-bottom: 2px solid transparent; cursor: pointer; transition: color .15s; }
  .psn-item.active { color: #76e1ff; border-bottom-color: #76e1ff; }
  .psn-icon { width: 20px; height: 20px; }
`;

export default function ProfileSubNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLang();
  return (
    <>
      <style>{css}</style>
      <div className="psn">
        {NAV_ITEMS.map(item => (
          <div
            key={item.path}
            className={'psn-item' + (location.pathname === item.path ? ' active' : '')}
            onClick={() => navigate(item.path)}
          >
            <span className="psn-icon">{item.icon}</span>
            {t(item.labelKey)}
          </div>
        ))}
      </div>
    </>
  );
}
